import { Link, useLocation, useNavigate } from "react-router-dom";
import { decodeJWT } from "../Components/jwtUtils";
import { useEffect, useState } from "react";
import Api from "../Auth/Api";
import { Modal } from "react-bootstrap";
import { useAjustes } from '../Context/AjustesContext';
import useAuth from "../Auth/hook_useAuth";

function Sidebar({ 
    showSidebar = false, 
    setShowSidebar = () => {}, 
    isCollapsed = false, 
    setIsCollapsed = () => {} 
}) {
    const location = useLocation();
    const navigate = useNavigate();
    const { signout } = useAuth();
    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivel = decodeJWT(token).nivel;
    const [mensagensNaoLidas, setMensagensNaoLidas] = useState([]);
    const [showModalRelatorios, setShowModalRelatorios] = useState(false);
    const { ajustes } = useAjustes();

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/mensagens-nao-lidas`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMensagensNaoLidas(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [token]);

    const isActive = (path) => location.pathname.includes(path);

    const handleMenuClick = () => {
        // Fechar sidebar no mobile após clicar em um item
        if (window.innerWidth <= 991) {
            setShowSidebar(false);
        }
    };

    const menuItems = [
        {
            path: nivel === 'Aluno' ? '/aluno/dashboard' : '/dashboard',
            icon: 'bi-grid-fill',
            label: 'Dashboard',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'Moderador'],
            isActive: (path) => isActive('/dashboard') || isActive('/aluno/dashboard')
        },
        {
            path: '/meus-cursos',
            icon: 'bi-journal-bookmark-fill',
            label: 'Meus Cursos',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'Moderador'],
            isActive: (path) => isActive('/meus-cursos') || isActive('/modulos/') || isActive('/aulas/') || isActive('/aula/')
        },
        {
            path: '/biblioteca',
            icon: 'bi-collection-fill',
            label: 'Biblioteca',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'Moderador'],
            isActive: (path) => isActive('/biblioteca')
        },
        {
            path: '/calendario',
            icon: 'bi-calendar3',
            label: 'Calendário',
            showFor: ['Aluno'],
            isActive: (path) => isActive('/calendario')
        }
    ];

    // Seção de Comunicação
    const comunicacaoMenuItems = [
        {
            path: '/chat',
            icon: 'bi-chat-dots-fill',
            label: 'Mensagens',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'Moderador'],
            isActive: (path) => isActive('/chat'),
            badge: mensagensNaoLidas.mensagens_nao_lidas
        }
    ];

    // Seção de Certificados e Documentos
    const certificadosMenuItems = [
        {
            path: nivel === 'Aluno' ? '/aluno/certificado' : '/certificados',
            icon: 'bi-award-fill',
            label: 'Certificados',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'Moderador'],
            isActive: (path) => isActive('/certificados') || isActive('/aluno/certificado')
        },
        {
            path: nivel === 'Aluno' ? '/aluno/historico-escolar' : '/historico-escolar',
            icon: 'bi-card-checklist',
            label: 'Histórico Escolar',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'Moderador'],
            isActive: (path) => isActive('/historico-escolar') || isActive('/aluno/historico-escolar')
        },
        {
            path: '/relatorios/logs',
            icon: 'bi-journal-text',
            label: 'Meus Logs',
            showFor: ['Aluno'],
            isActive: (path) => isActive('/relatorios/logs')
        },
        {
            path: '/configuracoes',
            icon: 'bi-gear',
            label: 'Ajustes',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'Moderador'],
            isActive: (path) => isActive('/configuracoes')
        }
    ];

    // Seção de Relatórios
    const relatoriosMenuItems = [
        {
            path: '#',
            icon: 'bi-graph-up',
            label: 'Relatórios',
            showFor: ['Administrador', 'Gestor', 'Moderador'],
            isActive: (path) => isActive('/relatorios/grupo') || isActive('/relatorios/aluno') || isActive('/relatorios/acompanhamento'),
            onClick: () => setShowModalRelatorios(true)
        }
    ];

    // Seção Administrativa
    const adminMenuItems = [
        {
            path: '/listar-usuarios',
            icon: 'bi-people-fill',
            label: 'Usuários',
            showFor: ['Administrador', 'Gestor', 'Moderador']
        },
        {
            path: '/listar-topicos',
            icon: 'bi-tags-fill',
            label: 'Gerenciar Temas',
            showFor: ['Administrador']
        },
        {
            path: '/listar-empresas',
            icon: 'bi-building',
            label: 'Empresas',
            showFor: ['Administrador', 'Moderador']
        },
        {
            path: '/listar-unidades',
            icon: 'bi-diagram-3',
            label: 'Unidades',
            showFor: ['Administrador', 'Moderador']
        },
        {
            path: '/listar-cargos',
            icon: 'bi-person-workspace',
            label: 'Cargos',
            showFor: ['Administrador', 'Moderador']
        },
        {
            path: '/ajustes',
            icon: 'bi-gear-wide-connected',
            label: 'Configurações do Sistema',
            showFor: ['Administrador']
        }
    ];

    return (
        <>
            <aside className={`sidebar-modern ${isCollapsed ? 'collapsed' : ''} ${showSidebar ? 'show' : ''}`}>
                {/* Header do Sidebar */}
                <div className="sidebar-header">
                    <div className="sidebar-brand">
                        {ajustes.logo_white ? (
                            <img 
                                src={ajustes.logo_white}
                                alt={ajustes.titulo || "Logo"}
                                className="sidebar-logo"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = './../assets/logo-white.png';
                                }}
                            />
                        ) : (
                            <img 
                                src="./../assets/logo-white.png"
                                alt="Logo"
                                className="sidebar-logo"
                            />
                        )}
                        {!isCollapsed && !ajustes.logo_white && (
                            <span className="sidebar-title">
                                {ajustes.titulo || 'Sistema'}
                            </span>
                        )}
                    </div>
                    
                    <button 
                        className="sidebar-toggle"
                        onClick={() => setIsCollapsed(!isCollapsed)}
                        title={isCollapsed ? 'Expandir' : 'Recolher'}
                    >
                        <i className={`bi ${isCollapsed ? 'bi-chevron-right' : 'bi-chevron-left'}`}></i>
                    </button>
                </div>

                {/* Navegação Principal */}
                <nav className="sidebar-nav">
                    <div className="nav-section">
                        {!isCollapsed && <div className="nav-section-title">Principal</div>}
                        <ul className="nav-list">
                            {menuItems.map((item, index) => (
                                item.showFor.includes(nivel) && (
                                    <li key={index} className="nav-item">
                                        <Link
                                            to={item.path}
                                            onClick={() => {
                                                if (item.onClick) item.onClick();
                                                handleMenuClick();
                                            }}
                                            className={`nav-link ${item.isActive(item.path) ? 'active' : ''}`}
                                            title={isCollapsed ? item.label : ''}
                                        >
                                            <div className="nav-icon">
                                                <i className={`bi ${item.icon}`}></i>
                                                {item.badge > 0 && (
                                                    <span className="nav-badge">
                                                        {item.badge}
                                                    </span>
                                                )}
                                            </div>
                                            {!isCollapsed && (
                                                <span className="nav-text">{item.label}</span>
                                            )}
                                        </Link>
                                    </li>
                                )
                            ))}
                        </ul>
                    </div>

                    {/* Seção de Comunicação */}
                    {comunicacaoMenuItems.some(item => item.showFor.includes(nivel)) && (
                        <div className="nav-section">
                            {!isCollapsed && <div className="nav-section-title">Comunicação</div>}
                            <ul className="nav-list">
                                {comunicacaoMenuItems.map((item, index) => (
                                    item.showFor.includes(nivel) && (
                                        <li key={index} className="nav-item">
                                            <Link
                                                to={item.path}
                                                onClick={handleMenuClick}
                                                className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                                                title={isCollapsed ? item.label : ''}
                                            >
                                                <div className="nav-icon">
                                                    <i className={`bi ${item.icon}`}></i>
                                                    {item.badge > 0 && (
                                                        <span className="nav-badge">
                                                            {item.badge}
                                                        </span>
                                                    )}
                                                </div>
                                                {!isCollapsed && (
                                                    <span className="nav-text">{item.label}</span>
                                                )}
                                            </Link>
                                        </li>
                                    )
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Seção de Certificados e Documentos */}
                    {certificadosMenuItems.some(item => item.showFor.includes(nivel)) && (
                        <div className="nav-section">
                            {!isCollapsed && <div className="nav-section-title">Certificados e Documentos</div>}
                            <ul className="nav-list">
                                {certificadosMenuItems.map((item, index) => (
                                    item.showFor.includes(nivel) && (
                                        <li key={index} className="nav-item">
                                            <Link
                                                to={item.path}
                                                onClick={handleMenuClick}
                                                className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                                                title={isCollapsed ? item.label : ''}
                                            >
                                                <div className="nav-icon">
                                                    <i className={`bi ${item.icon}`}></i>
                                                    {item.badge > 0 && (
                                                        <span className="nav-badge">
                                                            {item.badge}
                                                        </span>
                                                    )}
                                                </div>
                                                {!isCollapsed && (
                                                    <span className="nav-text">{item.label}</span>
                                                )}
                                            </Link>
                                        </li>
                                    )
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Seção de Relatórios */}
                    {relatoriosMenuItems.some(item => item.showFor.includes(nivel)) && (
                        <div className="nav-section">
                            {!isCollapsed && <div className="nav-section-title">Relatórios</div>}
                            <ul className="nav-list">
                                {relatoriosMenuItems.map((item, index) => (
                                    item.showFor.includes(nivel) && (
                                        <li key={index} className="nav-item">
                                            <Link
                                                to={item.path}
                                                onClick={() => {
                                                    if (item.onClick) item.onClick();
                                                    handleMenuClick();
                                                }}
                                                className={`nav-link ${item.isActive(item.path) ? 'active' : ''}`}
                                                title={isCollapsed ? item.label : ''}
                                            >
                                                <div className="nav-icon">
                                                    <i className={`bi ${item.icon}`}></i>
                                                </div>
                                                {!isCollapsed && (
                                                    <span className="nav-text">{item.label}</span>
                                                )}
                                            </Link>
                                        </li>
                                    )
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Seção Administrativa */}
                    {adminMenuItems.some(item => item.showFor.includes(nivel)) && (
                        <div className="nav-section">
                            {!isCollapsed && <div className="nav-section-title">Administração</div>}
                            <ul className="nav-list">
                                {adminMenuItems.map((item, index) => (
                                    item.showFor.includes(nivel) && (
                                        <li key={index} className="nav-item">
                                            <Link
                                                to={item.path}
                                                onClick={handleMenuClick}
                                                className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                                                title={isCollapsed ? item.label : ''}
                                            >
                                                <div className="nav-icon">
                                                    <i className={`bi ${item.icon}`}></i>
                                                </div>
                                                {!isCollapsed && (
                                                    <span className="nav-text">{item.label}</span>
                                                )}
                                            </Link>
                                        </li>
                                    )
                                ))}
                            </ul>
                        </div>
                    )}
                </nav>

                {/* Footer do Sidebar */}
                <div className="sidebar-footer">
                    <button
                        onClick={() => {
                            signout();
                            navigate("/");
                        }}
                        className={`nav-link`}
                        title={isCollapsed ? 'Sair' : ''}
                        style={{
                            background: 'none',
                            border: 'none',
                            width: '100%',
                            textAlign: 'left',
                            color: 'rgba(255, 255, 255, 0.8)',
                            cursor: 'pointer'
                        }}
                    >
                        <div className="nav-icon">
                            <i className="bi bi-box-arrow-right"></i>
                        </div>
                        {!isCollapsed && (
                            <span className="nav-text">Sair</span>
                        )}
                    </button>
                </div>
            </aside>

            {/* Modal de Relatórios - mantido igual */}
            <Modal size="lg" show={showModalRelatorios} onHide={() => setShowModalRelatorios(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-center w-100">
                        Relatórios
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#f9f9f9" }}>
                    <div className="container mt-2">
                        <div className="text-center mb-4">
                            <h5>Selecione um Relatório</h5>
                            <p className="text-muted">Escolha o tipo de relatório que você deseja visualizar.</p>
                        </div>
                        <div className="list-group">
                            <Link
                                to="/relatorios/grupo"
                                onClick={() => setShowModalRelatorios(false)}
                                className="list-group-item list-group-item-action d-flex align-items-center p-3"
                            >
                                <i className="bi bi-people-fill display-4 text-success me-3"></i>
                                <div>
                                    <h5 className="mb-0">Aulas em Grupo</h5>
                                    <small className="text-muted">Visualize o progresso das aulas em grupo.</small>
                                </div>
                            </Link>
                            <Link
                                to="/relatorios/aluno"
                                onClick={() => setShowModalRelatorios(false)}
                                className="list-group-item list-group-item-action d-flex align-items-center p-3"
                            >
                                <i className="bi bi-person-lines-fill display-4 text-primary me-3"></i>
                                <div>
                                    <h5 className="mb-0">Progresso do Aluno</h5>
                                    <small className="text-muted">Acompanhe o progresso individual dos alunos.</small>
                                </div>
                            </Link>
                            <Link
                                to="/relatorios/acompanhamento"
                                onClick={() => setShowModalRelatorios(false)}
                                className="list-group-item list-group-item-action d-flex align-items-center p-3"
                            >
                                <i className="bi bi-credit-card-2-front display-4 text-info me-3"></i>
                                <div>
                                    <h5 className="mb-0">Acompanhamento de Treinamentos</h5>
                                    <small className="text-muted">Monitore o andamento e desempenho dos treinamentos.</small>
                                </div>
                            </Link>
                            {(nivel === 'Administrador' || nivel === 'Moderador') && (
                                <>
                                    <Link
                                        to="/relatorios/feedback"
                                        onClick={() => setShowModalRelatorios(false)}
                                        className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                    >
                                        <i className="bi bi-graph-up display-4 text-warning me-3"></i>
                                        <div>
                                            <h5 className="mb-0">Estatísticas de Feedback</h5>
                                            <small className="text-muted">Visualize as estatísticas das pesquisas de satisfação.</small>
                                        </div>
                                    </Link>
                                    <Link
                                        to="/relatorios/avaliacao-reacao"
                                        onClick={() => setShowModalRelatorios(false)}
                                        className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                    >
                                        <i className="bi bi-emoji-smile display-4 text-success me-3"></i>
                                        <div>
                                            <h5 className="mb-0">Avaliação de Reação</h5>
                                            <small className="text-muted">Estatísticas das avaliações de reação.</small>
                                        </div>
                                    </Link>
                                    <Link
                                        to="/relatorios/avaliacao-reacao-hibrido"
                                        onClick={() => setShowModalRelatorios(false)}
                                        className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                    >
                                        <i className="bi bi-gem display-4 text-primary me-3"></i>
                                        <div>
                                            <h5 className="mb-0">Avaliação de Reação Híbrido</h5>
                                            <small className="text-muted">Estatísticas das avaliações de reação para treinamentos híbridos.</small>
                                        </div>
                                    </Link>
                                    <Link
                                        to="/relatorios/avaliacao-eficacia"
                                        onClick={() => setShowModalRelatorios(false)}
                                        className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                    >
                                        <i className="bi bi-check2-circle display-4 text-info me-3"></i>
                                        <div>
                                            <h5 className="mb-0">Avaliação de Eficácia</h5>
                                            <small className="text-muted">Estatísticas das avaliações de eficácia.</small>
                                        </div>
                                    </Link>
                                </>
                            )}
                            {(nivel === 'Administrador' || nivel === 'Moderador' || nivel === 'Gestor') && (
                                <Link
                                    to="/relatorios/logs"
                                    onClick={() => setShowModalRelatorios(false)}
                                    className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                >
                                    <i className="bi bi-journal-text display-4 text-secondary me-3"></i>
                                    <div>
                                        <h5 className="mb-0">Logs do Sistema</h5>
                                        <small className="text-muted">Visualize o histórico de ações realizadas no sistema.</small>
                                    </div>
                                </Link>
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <button className="btn btn-outline-primary" onClick={() => setShowModalRelatorios(false)}>
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Sidebar;